"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const tools = [{
  category: "[PHENOLIC / INDUSTRIAL]",
  name: "MIL-SPEC Phenolic",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/phenolic_plate.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/phenolic_plate.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/phenolic_plate.png-wvc-sizes",
  spec: "[MAT-01]",
  spec1Label: "THICKNESS",
  spec1Value: "1/16\" - 1/8\"",
  spec2Label: "RESISTANCE",
  spec2Value: "CHEMICAL",
  spec3Label: "COMPLIANCE",
  spec3Value: "MIL-P-15024",
  rationale: "The standard for harsh environments. Resists heat, solvents, and physical impact."
}, {
  category: "[STAINLESS / STEEL]",
  name: "316 Stainless Steel",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/stainless_tag.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/stainless_tag.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/stainless_tag.png-wvc-sizes",
  spec: "[MAT-02]",
  spec1Label: "GRADE",
  spec1Value: "316/304",
  spec2Label: "FINISH",
  spec2Value: "BRUSHED",
  spec3Label: "MARKING",
  spec3Value: "LASER ETCH",
  rationale: "Corrosion-resistant for marine and chemical processing plants. Permanent ID."
}, {
  category: "[ACRYLIC / LEGEND]",
  name: "Two-Color Acrylic",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/acrylic_legend.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/acrylic_legend.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/acrylic_legend.png-wvc-sizes",
  spec: "[MAT-03]",
  spec1Label: "CORE",
  spec1Value: "ABS PLASTIC",
  spec2Label: "MOUNTING",
  spec2Value: "ADHESIVE",
  spec3Label: "VISIBILITY",
  spec3Value: "HIGH CONTRAST",
  rationale: "Clean, sharp engraving for control panels and electrical switchgear identification."
}, {
  category: "[ALUMINUM / ANODIZED]",
  name: "Anodized Aluminum",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/anodized_aluminum.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/anodized_aluminum.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/anodized_aluminum.png-wvc-sizes",
  spec: "[MAT-04]",
  spec1Label: "PROCESS",
  spec1Value: "ANODIZED",
  spec2Label: "WEIGHT",
  spec2Value: "LIGHTWEIGHT",
  spec3Label: "DURABILITY",
  spec3Value: "UV STABLE",
  rationale: "Excellent for asset tags and serial plates. Resists fading in outdoor sunlight."
}, {
  category: "[BRASS / ENGRAVED]",
  name: "Industrial Brass",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/brass_tag.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/brass_tag.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/brass_tag.png-wvc-sizes",
  spec: "[MAT-05]",
  spec1Label: "ALLOY",
  spec1Value: "C360",
  spec2Label: "FINISH",
  spec2Value: "NATURAL",
  spec3Label: "USE",
  spec3Value: "VALVE TAGS",
  rationale: "Classic, non-sparking material for valve identification and high-end equipment."
}, {
  category: "[ARC FLASH / SAFETY]",
  name: "Arc Flash Labels",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/arc_flash_label.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/arc_flash_label.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/arc_flash_label.png-wvc-sizes",
  spec: "[MAT-06]",
  spec1Label: "MATERIAL",
  spec1Value: "POLYESTER",
  spec2Label: "RATING",
  spec2Value: "NFPA 70E",
  spec3Label: "ADHESIVE",
  spec3Value: "INDUSTRIAL",
  rationale: "Critical safety compliance. High-visibility warnings for electrical hazards."
}, {
  category: "[CABLE / WIRE ID]",
  name: "Cable ID Tags",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/cable_tag.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/cable_tag.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/cable_tag.png-wvc-sizes",
  spec: "[MAT-07]",
  spec1Label: "MATERIAL",
  spec1Value: "STAINLESS",
  spec2Label: "ATTACH",
  spec2Value: "TIE-WRAP",
  spec3Label: "LEGIBILITY",
  spec3Value: "PERMANENT",
  rationale: "Ensures cable runs are traceable in complex industrial infrastructure."
}, {
  category: "[DPM / DIRECT]",
  name: "Direct Part Marking",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/dpm_marking.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/dpm_marking.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/dpm_marking.png-wvc-sizes",
  spec: "[MAT-08]",
  spec1Label: "METHOD",
  spec1Value: "LASER ABLATE",
  spec2Label: "SURFACE",
  spec2Value: "METAL/PLASTIC",
  spec3Label: "TRACE",
  spec3Value: "SERIALIZED",
  rationale: "Marking directly onto components for permanent traceability and inventory control."
}];
export default function () {
  const {
    ref: headerRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="1769" id="material-inventory" className="relative bg-background py-28 md:py-40 overflow-hidden">
      <div aria-hidden="true" className="absolute top-0 left-0 right-0 h-6 opacity-10" style={{
      backgroundImage: "repeating-linear-gradient(45deg, var(--color-foreground) 0 2px, transparent 2px 6px), repeating-linear-gradient(-45deg, var(--color-foreground) 0 2px, transparent 2px 6px)"
    }} />

      <div className="max-w-[1360px] mx-auto px-6 md:px-8 lg:px-16">
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 mb-16 md:mb-24 transition-all duration-500 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="lg:col-span-8">
            <div className="flex items-center gap-3 mb-6">
              <span aria-hidden="true" className="inline-block w-[10px] h-[10px] bg-chart-1" />
              <span className="font-mono text-xs md:text-sm font-semibold uppercase tracking-[0.18em] text-foreground">
                § 02 — Material Inventory
              </span>
            </div>

            <h2 className="font-default font-black uppercase leading-[0.92] text-foreground" style={{
            fontSize: "clamp(2.5rem, 5.4vw, 5rem)",
            letterSpacing: "-0.015em"
          }}>
              The{" "}
              <em className="not-italic text-chart-1">
                Materials
              </em>{" "}
              We Engineer For.
            </h2>
          </div>

          <div className="lg:col-span-4 flex flex-col justify-end gap-5">
            <p className="font-default text-base md:text-lg leading-[1.55] text-muted-foreground">
              We don't just mark parts; we select the substrate that survives your environment. From MIL-SPEC phenolic to stainless steel, these are the materials we trust for permanent identification.
            </p>
            <div className="inline-flex">
              <span className="font-mono text-xs font-semibold uppercase px-2 py-1 border border-chart-1 text-chart-1 tracking-[0.12em]">
                [COMPLIANT / INDUSTRIAL GRADE]
              </span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border border-border">
          {tools.map((tool, i) => <article key={i} data-index={i} className="group relative flex flex-col min-h-[380px] bg-card border-r border-b border-border">
              <span aria-hidden="true" className="absolute top-2 left-2 w-1.5 h-1.5 rounded-lg z-10 bg-foreground" />
              <span aria-hidden="true" className="absolute top-2 right-2 w-1.5 h-1.5 rounded-lg z-10 bg-foreground" />
              <span aria-hidden="true" className="absolute bottom-2 left-2 w-1.5 h-1.5 rounded-lg z-10 bg-foreground" />
              <span aria-hidden="true" className="absolute bottom-2 right-2 w-1.5 h-1.5 rounded-lg z-10 bg-foreground" />

              <div className="relative h-48 flex items-center justify-center overflow-hidden transition-colors duration-300 bg-secondary">
                <div aria-hidden="true" className="absolute inset-0 opacity-0 group-hover:opacity-10 transition-opacity duration-300 bg-chart-1" />
                <img src={tool.image} data-wvc-srcset={tool.srcset} data-wvc-sizes={tool.sizes} alt={tool.name} loading="lazy" decoding="async" className="relative z-[1] max-h-full max-w-full object-contain p-6" />
                <span className="absolute top-3 right-3 z-[2] font-mono text-[0.7rem] font-semibold uppercase px-1.5 py-0.5 bg-chart-1 text-card tracking-[0.12em]">
                  {tool.spec}
                </span>
              </div>

              <div className="flex flex-col flex-1 p-6 gap-4">
                <div className="font-mono text-xs font-semibold uppercase tracking-[0.12em] text-chart-1">
                  {tool.category}
                </div>

                <h3 className="font-default font-bold uppercase leading-none text-foreground" style={{
              fontSize: "clamp(1.25rem, 1.8vw, 1.5rem)",
              letterSpacing: "-0.005em"
            }}>
                  {tool.name}
                </h3>

                <dl className="flex flex-col gap-1.5 pt-3 border-t border-border">
                  <div className="flex justify-between font-mono text-[0.7rem] uppercase">
                    <dt className="text-muted-foreground tracking-[0.12em]">
                      {tool.spec1Label}
                    </dt>
                    <dd className="text-foreground tracking-[0.08em]">
                      {tool.spec1Value}
                    </dd>
                  </div>
                  <div className="flex justify-between font-mono text-[0.7rem] uppercase">
                    <dt className="text-muted-foreground tracking-[0.12em]">
                      {tool.spec2Label}
                    </dt>
                    <dd className="text-foreground tracking-[0.08em]">
                      {tool.spec2Value}
                    </dd>
                  </div>
                  <div className="flex justify-between font-mono text-[0.7rem] uppercase">
                    <dt className="text-muted-foreground tracking-[0.12em]">
                      {tool.spec3Label}
                    </dt>
                    <dd className="text-foreground tracking-[0.08em]">
                      {tool.spec3Value}
                    </dd>
                  </div>
                </dl>

                <div className="mt-auto pt-3">
                  <div className="font-mono text-[0.65rem] font-semibold uppercase mb-1.5 tracking-[0.15em] text-chart-1">
                    Why It Works
                  </div>
                  <p className="font-default text-sm leading-[1.5] text-muted-foreground">
                    {tool.rationale}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}